import { gql } from '@apollo/client';

export const ALL_TEMPLATE_TAGS = gql`
  query getTemplateTags($input: TemplateTagFilterInput!) {
    templateTags: getTemplateTags(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
